<template>
  <v-container class="py-0">
    <v-card
      class="py-2"
      max-width="420"
      :style="{ backgroundColor: amnioResearchPatientType === 'control' ? '#daffda' : '#f6f6dd', 'border': 'thin solid rgba(0, 0, 0, 0.14) !important', 'border-radius': '6px' }"
    >
      <v-row no-gutters>
        <v-col>
          <v-card-text class="text-h6 font-weight-bold">
            {{ patientName }}
          </v-card-text>
        </v-col>
        <v-col class="text-center">
          <v-chip
            :color="amnioResearchPatientType === 'control' ? '#16ce22' : '#ead600'"
          >
            <icon-value
              :icon="icons.mdiAccount"
              color="white"
              start
            ></icon-value>
            {{ amnioResearchPatientType ? amnioResearchPatientType.toUpperCase() : "TBA" }}
          </v-chip>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="5">
          <v-card-text class="font-weight-regular pl-5 py-0">
            Provider
          </v-card-text>
          <v-card-text class="pl-5 py-0" style="font-size: 18px;">
            {{ user.name }}
          </v-card-text>
        </v-col>
        <v-col cols="7">
          <v-card-text class="font-weight-regular py-0">
            Facility
          </v-card-text>
          <v-card-text class="text-uppercase py-0" style="font-size: 18px;">
            {{ facility }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { mdiAccount } from '@mdi/js'

export default {
  name: 'ResearchInoCard',
  components: {},
  props: {
    patientName: {
      type: String,
      default: '',
    },
    amnioResearchPatientType: {
      type: String,
      default: null,
    },
    facilityId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      amnio_research_patient_type: this.amnioResearchPatientType,
      facility: this.$store.getters['facilities/getById'](this.facilityId).title.toUpperCase(),
      patient_name: this.patientName,
      icons: {
        mdiAccount,
      },
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
  },
  watch: {
  },
  methods: {
  },
}
</script>
